import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class OrgInviteAccepted extends BaseAction {
    public static userVisible:boolean = false;
    public static getTitle:Function = () => Locale.gettext('Org Invite Accepted');
    public static getDescription:Function = () => Locale.gettext('A user accepted your request to join the organization');
}